<template>
    <div class="chart">
        <section class="home-cards">
        <h4>Guidelines for Class displays</h4>
        <hr class="hr">
        <div class="home-cards-main">
            <div class="feature">
                <div class="feature-img undraw">
                <img src="@/assets/logo.svg" alt="bank details">
                </div>
                <div class="feature-title">
                <h5>How to make charts</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>Identify the type of chart you want to make.</li>
                  <li>Relate the information to your teaching objectives.</li>
                  <li>Information should be appropriate for the grade</li>
                  <li>Drawings should be large enough to be seen from a distance. </li>
                  <li>Use the correct handwriting for the particular grade.</li>
                  <li>The chart should not be overcrowded.</li>
                  <li>Always make a borderline</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>How to display charts</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>Create sections for subjects in your classroom.</li>
                  <li>Have clear subject headings.</li>
                  <li>Position the charts neatly and in a creative manner.</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>Advantages of teaching aides</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>Complement verbal instructions.</li>
                  <li>Saves time and energy. </li>
                  <li>Makes learning permanent.</li>
                </ol>
                </div>
                <div class="feature-title">
                <h5>Examples of teaching aides</h5>
                </div>
                <div class="feature-detail">
                <ol>
                  <li>Charts.</li>
                  <li>Physical objects.</li>
                  <li>Models and experiments.</li>
                  <li>Pictures.</li>
                </ol>
                </div>
            </div>
        </div>
        </section>
    </div>
</template>

<script>

export default {
  name: 'ChartDisplay',
  components: { }
}
</script>

<style>
.chart .home-cards .hr {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 2em;
}
.chart .home-cards h4 {
  padding-top: 2em;
  font-size: 2em;
  font-weight: 700;
  letter-spacing: 2px;
  padding-bottom: 4px;
  color: #fff;
}
.chart .home-cards .home-cards-main {
  padding: 1em;
  max-width: 800px;
  margin: 10px auto;
  background-color: var(--inspire-gold);
}
.chart .feature {
  margin: 5px;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: .5s ease all;
}
.chart .feature:hover {
  box-shadow: 10px 10px 26px rgba(0, 0, 0, 0.5);
}
.chart .feature h5 {
  font-size: 1.8em;
  color: #fff;
  font-weight: 500;
  padding: 4px;
}
.chart .feature p {
  color: var(--inspire-charcoal);
}
.chart .feature .feature-img {
  width: 45px;
  margin: 5px auto;
}
.chart .feature .feature-img.undraw {
  width: 85px;
  margin: 5px auto;
}
.chart .feature .feature-detail {
  padding: 8px;
  font-size: 1.2em;
}
</style>
